export enum ETransactionAction {
  ActionBuy = 'buy',
  ActionSell = 'sell',
  ActionDeposit = 'deposit',
  ActionWithdrawal = 'withdrawal',
  ActionApproval = 'approval',
  ActionBaseBuyEth = 'base_buy_eth',
  ActionBaseSellEth = 'base_sell_eth',
  ActionQuoteSellEth = 'quote_sell_eth',
  ActionBaseBuyEthHolder = 'base_buy_eth_holder',
  ActionQuoteBuyEthHolder = 'quote_buy_eth_holder',
  ActionBulkBuy = 'bulk_buy',
  ActionBulkSell = 'bulk_sell',
  ActionBulkBuyMempool = 'bulk_buy_mempool',
  ActionBulkSellMempool = 'bulk_sell_mempool',
  ActionAddLiquidity = 'add_liquidity',
  ActionRemoveLiquidity = 'remove_liquidity',
  ActionAFRBuy = 'afr_buy',
  ActionAFRSell = 'afr_sell',
}
